/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
/**
 * @file  EventsItem组件
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */

import React, {useEffect, useState} from 'react';
import {Button, Popover} from 'antd';
import {useHistory} from 'react-router-dom';
import Iconfont from '~/component/Iconfont';

import './index.less';

function Item({
    item: {id, uid, content: {webcast, title, date, time, timeZone, earningsRelease, presentation, transcript, infographic}},
    type
}) {
    const history = useHistory();

    function handleCalendar() {
        const {href, pathname} = window.location;
        const prefix = href.substr(0, href.indexOf(pathname));
        const url = `/news/detail/${uid}`;
        const fullUrl = prefix + url;
        window.open(
            `/api/schedule/download.json?title=${title}&dtStart=${`${date} ${time} ${timeZone}`}&detailUrl=${fullUrl}`
        );
    }

    function handleClick() {
        history.push(`/news/detail/${uid}?type=${type}`);
    }

    return (
        <div className="events-item-container">
            <div>
                <div className="events-title" onClick={handleClick} role="presentation">
                    {title}
                </div>
                <div
                    role="button"
                    tabIndex={0}
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() => (type === 'upcoming-event' ? handleCalendar() : handleClick())}
                    className="events-date"
                >
                    {`${`${date} ${time}`} ${timeZone}`}

                    {type === 'upcoming-event' && (
                        <Popover content="Add to Calendar">
                            <Iconfont type="iconrili" className="iconrili" />
                        </Popover>
                    )}
                </div>
            </div>
            <div className="events-items">
                {
                    webcast && (
                        <a href={webcast} target="_blank">
                            <Button
                                icon={
                                    <Iconfont type="iconguangbo" className="icon" />
                                }
                            >
                                Webcast
                            </Button>
                        </a>
                    )
                }

                {!!earningsRelease && (
                    <a href={earningsRelease[0].url} target="_blank">
                        <Button
                            icon={
                                <Iconfont type="iconfujian" className="icon" />
                            }
                        >
                            Release
                        </Button>
                    </a>
                ) }
                {!!presentation && (
                    <a href={presentation[0].url} target="_blank">
                        <Button
                            icon={
                                <Iconfont type="iconfujian" className="icon" />
                            }
                        >
                            Presentation
                        </Button>
                    </a>
                )}
                {!!transcript && (
                    <a href={transcript[0].url} target="_blank">
                        <Button
                            icon={
                                <Iconfont type="iconfujian" className="icon" />
                            }
                        >
                            Transcript
                        </Button>
                    </a>
                )}
                {!!infographic && (
                    <a href={infographic.url} target="_blank">
                        <Button
                            icon={
                                <Iconfont type="iconfujian" className="icon" />
                            }
                        >
                            Infographic
                        </Button>
                    </a>
                )}
            </div>
        </div>

    );
}

export default Item;
